<template>
  <el-dropdown class="dropdown" trigger="click" @visible-change="visibleChange">
    <slot name="trigger"> </slot>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="item in menuOptions" :key="item.key" class="custom-dropdown-item">
        <span @click="handleSelect(item.key)">{{ item.label }}</span>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import Login from 'utils/login';
import { ROLES } from 'constants/role';
import LoginHelper from 'utils/login';
import wx from 'weixin-js-sdk';

export default {
  name: 'UserDropdown',
  computed: {
    loginData() {
      return this.$login.lastLoginData;
    },
    ROLES() {
      return ROLES;
    },
    userType() {
      return this.$store.state.lastLoginType;
    },
    previous() {
      return this.infoData.previous_transcript;
    },
    phone() {
      return this.infoData.phone;
    },
    teacherName() {
      return this.$store.state.teacherLoginData.name || '老师';
    },
    behaviorType() {
      return this.statusData?.activate_status_v5?.has_password ? 'reset' : 'set';
    },
    behaviorName() {
      return this.behaviorType === 'set' ? '设置密码' : '修改密码';
    },
    menuOptions() {
      if (this.userType === ROLES.STUDENT) {
        const studentOptions = [
          {
            key: 'my-account',
            label: '我的资料'
          },
          {
            key: 'set-password',
            label: this.behaviorName
          }
        ];
        // 如果是非小程序，头部插入My HSYLC
        if (!this.$isMiniProgram) {
          studentOptions.unshift({
            key: 'my-hsylc',
            label: 'My HSYLC'
          });
        }

        if (this.previous > 0) {
          studentOptions.push({
            key: 'check-grade',
            label: '往年成绩'
          });
        }

        studentOptions.push({
          key: 'logout',
          label: '退出登录'
        });

        return studentOptions;
      } else if (this.userType === ROLES.TEACHER) {
        const teacherOptions = [
          {
            key: 'my-hsylc',
            label: 'My HSYLC'
          },
          {
            key: 'logout',
            label: '退出登录'
          }
        ];
        // 如果是非小程序，头部插入My HSYLC
        if (!this.$isMiniProgram) {
          teacherOptions.unshift({
            key: 'my-hsylc',
            label: 'My HSYLC'
          });
        }
        return teacherOptions;
      }
      return [];
    }
  },
  data: () => ({
    menuActive: false,
    infoData: {},
    statusData: {}
  }),
  async created() {
    if (LoginHelper.isLogin()) {
      this.statusData = await LoginHelper.getStatusData();
    }
  },
  async mounted() {
    this.$student.getInfo().then(data => {
      this.infoData = data;
      return;
    });
  },
  methods: {
    handleSelect(key) {
      this.$emit('select', key);
      switch (key) {
        case 'my-hsylc':
          this.toMyHsylc();
          break;
        case 'my-account':
          this.myAccount();
          break;
        case 'set-password':
          this.setPassword();
          break;
        case 'check-grade':
          this.checkGrade();
          break;
        case 'logout':
          this.handleClickLogout();
          break;
      }
    },
    toMyHsylc() {
      this.$redirectToMyHsylc();
    },
    visibleChange(e) {
      this.menuActive = e;
      this.$emit('visible-change', e);
    },
    myAccount() {
      this.$router.push({
        path: '/account'
      });
    },
    checkGrade() {
      this.$router.push({
        path: '/student/previous/info'
      });
    },
    handleClickLogout() {
      if (this.$isMiniProgram) {
        wx.miniProgram.reLaunch({ url: '/pages/Hsylc/index?logout=true' });
      } else {
        Login.setLogout();
        this.$location('/login');
      }
    },
    setPassword() {
      if (this.$isMiniProgram) {
        wx.miniProgram.navigateTo({ url: '/pages/resetPwd/index' });
      } else {
        const track = new this.$track();
        track.track('hsylc_password_edit', { beacon: true });
      }
    }
  }
};
</script>

<style lang="less" scoped src="./index.less"></style>
